<template>
  <div v-if="isBrandingActive" id="_branding-wrap" class="branding-wrap">
    <a
      v-if="company && company.logoURL"
      :href="'//' + company.domain"
      class="branding-url"
      target="_blank"
    >
      <img :src="company.logoURL" alt="" />
      <span class="cmp-name">{{ company.name }}</span>
    </a>
    <a
      v-else-if="company"
      href="https://gohighlevel.com"
      class="branding-url"
      target="_blank"
      :aria-label="t('common.goHighLevel')"
    >
      <AgencyBrnadingLogo></AgencyBrnadingLogo>
    </a>
  </div>
</template>

<script setup lang="ts">
import AgencyBrnadingLogo from "./../../assets/icons/agency-branding.svg";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps({
  isBrandingActive: {
    type: Boolean,
    default: false,
  },
  company: {
    type: Object,
    default() {
      return {};
    },
  },
});
</script>

<style scoped>
#_branding-wrap {
  position: relative;
  padding: 0px 16px 10px;
}

.branding-url {
  display: block;
  padding: 0;
  text-align: left;
}

.branding-url > img {
  width: 100px;
}

.branding-url .cmp-name {
  color: #607179;
  font-size: 12px;
  /* margin-left: 9px; */
  display: block;
}
</style>
